import { createTranslationRef } from '@backstage/core-plugin-api/alpha';

export const rootTranslationRef = createTranslationRef({
  id: 'app.root',
  messages: {
    sidebar: {
      group: {
        search: 'Search',
        menu: 'Menu',
        navigation: 'Navigation',
        settings: 'Settings',
      },
      link: {
        home: 'Home',
        apis: 'APIs',
        docs: 'Docs',
        create: 'Create...',
        register: 'Register Existing',
        notifications: 'Notifications',
      },
      toggle: {
        pin: 'Pin Menu',
        unpin: 'Unpin Menu',
      },
    },
  },
});
